import { gql } from '@apollo/client'
import { DropdownOption } from 'shared/models/dropdownOption'

export interface CandidateAboutMeOptions {
    employmentTypes: DropdownOption[]
    provinces: DropdownOption[]
    countries: DropdownOption[]
    states: DropdownOption[]
    genders: DropdownOption[]
    ethnicities: DropdownOption[]
    lgbtq: DropdownOption[]
    visaStatuses: DropdownOption[]
    programs: DropdownOption[]
    veteranStatuses: DropdownOption[]
    languages: DropdownOption[]
}

export const CandidateAboutMeOptionsQuery = gql`
    query AboutMeOptions {
        employmentTypes {
            id
            value
        }
        provinces {
            id
            value
        }
        countries {
            id
            value
        }
        states {
            id
            value
        }
        genders {
            id
            value
        }
        ethnicities {
            id
            value
        }
        lgbtq {
            id
            value
        }
        visaStatuses {
            id
            value
        }
        programs {
            id
            value
        }
        veteranStatuses {
            id
            value
        }
        languages {
            id
            value
        }
    }
`

export interface CandidateEducationOptions {
    degreeTypes: DropdownOption[]
    colleges: DropdownOption[]
    majors: DropdownOption[]
}

export const CandidateEducationOptionsQuery = gql`
    query CandidateEducationOptionsQuery {
        degreeTypes {
            id
            value
        }
        colleges {
            id
            value
        }
        mbaColleges {
            id
            value
        }
        majors {
            id
            value
        }
    }
`

export interface CandidateReferencesOptions {
    titles: DropdownOption[]
}

export const CandidateReferencesOptionsQuery = gql`
    query ReferencesOptions {
        titles {
            id
            value
        }
    }
`

export interface CandidateAdditionalInformationOptions {
    industries: DropdownOption[]
    sectors: DropdownOption[]
    tiers: DropdownOption[]
    titles: DropdownOption[]
}

export const CandidateAdditionalInformationOptionsQuery = gql`
    query AdditionalInformationOptions {
        industries {
            id
            value
        }
        sectors {
            id
            value
        }
        titles {
            id
            value
        }
        tiers {
            id
            value
        }
    }
`

export const UpdateCandidateBioMutation = gql`
    mutation UpdateCandidateBio(
        $id: ID!
        $phone: String!
        $linkedinUrl: String
    ) {
        updateCandidateBio(id: $id, phone: $phone, linkedinUrl: $linkedinUrl) {
            id
            linkedinUrl
            user {
                id
                firstName
                lastName
                nickname
                email
                phone
                isActive
                roles
                profileImageKey
            }
        }
    }
`

export const UpdateCandidateAboutMeMutation = gql`
    mutation updateCandidateAboutMe(
        $id: ID!
        $employmentTypeId: ID
        $startYear: String
        $city: String
        $provinceId: ID
        $stateId: ID
        $countryId: ID
        $genderId: ID
        $lgbtqId: ID
        $visaStatusIds: [ID!]
        $programIds: [ID!]
        $veteranStatusId: ID
        $languageIds: [ID!]
        $ethnicityIds: [ID!]
    ) {
        updateCandidateAboutMe(
            id: $id
            employmentTypeId: $employmentTypeId
            startYear: $startYear
            city: $city
            provinceId: $provinceId
            stateId: $stateId
            countryId: $countryId
            genderId: $genderId
            ethnicityIds: $ethnicityIds
            lgbtqId: $lgbtqId
            visaStatusIds: $visaStatusIds
            programIds: $programIds
            veteranStatusId: $veteranStatusId
            languageIds: $languageIds
        ) {
            success
            message
        }
    }
`

export const updateCandidateReferencesMutation = gql`
    mutation References($id: ID, $references: [ReferenceEntry!]) {
        updateCandidateReferences(id: $id, references: $references) {
            success
            message
        }
    }
`

export const deleteDocument = gql`
    mutation DeleteDocument($documentId: String!) {
        deleteDocument(documentId: $documentId) {
            success
            message
        }
    }
`

export const downloadDocument = gql`
    query DownloadDocument($documentId: String!) {
        download(documentId: $documentId) {
            url
        }
    }
`

export const updateDocumentType = gql`
    mutation UpdateCandidateDocumentType(
        $documentId: String!
        $documentType: String!
    ) {
        updateCandidateDocumentType(
            documentId: $documentId
            documentType: $documentType
        ) {
            success
        }
    }
`
